"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = exports.UserAvatar = exports.UserAvatarSizeMap = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var toHTMLDataTags_1 = require("../../utils/toHTMLDataTags");
exports.UserAvatarSizeMap = {
    large: 'large',
    medium: 'medium',
    mediumLarge: 'mediumLarge',
    normal: 'normal'
};
var UserAvatar = function (_a) {
    var _b = _a.dataTags, dataTags = _b === void 0 ? {} : _b, _c = _a.size, size = _c === void 0 ? 'normal' : _c, _d = _a.style, style = _d === void 0 ? {} : _d, text = _a.text;
    return (React.createElement(exports.Circle, __assign({ style: getCircleSize(size) }, toHTMLDataTags_1.toHTMLDataTags(dataTags)),
        React.createElement(Text, { style: style.text }, text)));
};
exports.UserAvatar = UserAvatar;
var getCircleSize = function (size) {
    var dim = '2.67rem';
    switch (size) {
        case exports.UserAvatarSizeMap.mediumLarge:
            dim = '5.8rem';
        case exports.UserAvatarSizeMap.large:
            dim = '6.66rem';
            break;
        case exports.UserAvatarSizeMap.medium:
            dim = '3.33rem';
            break;
        default:
    }
    return {
        height: dim,
        width: dim
    };
};
exports.Circle = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.16rem;\n  font-weight: 700;\n  border-radius: 50%;\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  text-transform: uppercase;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.16rem;\n  font-weight: 700;\n  border-radius: 50%;\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  text-transform: uppercase;\n"])), theme_1.colors.primary, theme_1.colors.white);
var Text = styled_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 1.67rem;\n  width: 100%;\n  text-align: center;\n  display: inline-block;\n  letter-spacing: 0.1rem;\n  line-height: 1.43;\n  font-weight: 300;\n  font-size: 1.167rem;\n"], ["\n  height: 1.67rem;\n  width: 100%;\n  text-align: center;\n  display: inline-block;\n  letter-spacing: 0.1rem;\n  line-height: 1.43;\n  font-weight: 300;\n  font-size: 1.167rem;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map